import { render, staticRenderFns } from "./PriTama02_Nico.vue?vue&type=template&id=f776de6e&scoped=true&"
import script from "./PriTama02_Nico.vue?vue&type=script&lang=js&"
export * from "./PriTama02_Nico.vue?vue&type=script&lang=js&"
import style0 from "./PriTama02_Nico.vue?vue&type=style&index=0&id=f776de6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f776de6e",
  null
  
)

export default component.exports